import { jsx as _jsx } from "react/jsx-runtime";
export function TitleBar({ title }) {
    return _jsx("div", { className: 'self-center text-lg font-semibold', children: title });
}
//# sourceMappingURL=TitleBar.js.map